import React from 'react'
import { SideMenu } from '../components'
import { useParams } from 'react-router-dom'

type Props = {
  children: any
}
export const Main: React.FC<Props> = ({ children }) => {
  const { processStatus }: any = useParams()
  return <SideMenu children={children} />
}
